import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { BehaviorSubject, map, Observable } from 'rxjs';
import { isPlatformBrowser } from '@angular/common';
import { LoginVerifyResponse, User } from '../data-models/user';
import { environment } from '../../../environments/environment';
import { SignInData } from '../data-models/sign-in-data';
import { OtpResponse } from '../data-models/otp-response';
import { ApiResponse } from '../data-models/api-response';
import { Profile } from '../data-models/profile';
@Injectable({
  providedIn: 'root'
})
export class AccountService {

  private baseUrl: string | undefined;
  private currentUserSource=new BehaviorSubject<LoginVerifyResponse|null>(null);
  currentUser$=this.currentUserSource.asObservable();

  private emailSource = new BehaviorSubject<string|null>(null);
  resetEmail = this.emailSource.asObservable();

  private phoneNumberSource = new BehaviorSubject<string | null>(null);
  phoneNumber$ = this.phoneNumberSource.asObservable();

  constructor(private http: HttpClient,@Inject(PLATFORM_ID) private platformId: object) {
    this.baseUrl = environment.apiUrl;
   }
  setPhoneNumber(phone: string) {
    this.phoneNumberSource.next(phone);
  }

   signUp(model: SignInData): Observable<ApiResponse<OtpResponse>> {
    const formData = new FormData();
    formData.append('name', model.name);
    formData.append('phone', model.phone);
    formData.append('email', model.email);

    this.setPhoneNumber(model.phone);

    return this.http.post<ApiResponse<OtpResponse>>(`${this.baseUrl}/client/auth/sign_up`, formData);
  }

  login(phone: string): Observable<ApiResponse<OtpResponse>> {
    const formData = new FormData();
    formData.append('phone', phone);
    formData.append('fcm_token', environment.fcm_token);
    formData.append('platform', environment.platform);

    return this.http.post<ApiResponse<OtpResponse>>(`${this.baseUrl}/client/auth/login`, formData);
  }

  verifyLogin(token: string): Observable<ApiResponse<LoginVerifyResponse>> {
    const phone = localStorage.getItem('phoneNumber');
    if (!phone) {
      throw new Error('Phone number is missing! Make sure you set it during sign-up.');
    }

    const formData = new FormData();
    formData.append('phone', phone);
    formData.append('token', token);
    formData.append('fcm_token', environment.fcm_token);
    formData.append('platform', environment.platform);

    // Send POST request with proper response type
    return this.http.post<ApiResponse<LoginVerifyResponse>>(`${this.baseUrl}/client/auth/login/verify`, formData).pipe(
      map((response) => {
        if (response.data) {
          this.setCurrentUser(response.data); // Store user data in service
        }
        return response;
      })
    );
  }

  GetProfile(): Observable<any> {
    return this.http.get(`${this.baseUrl}/client/auth/profile`);
  }
  
  UpdateProfile(formData: FormData): Observable<ApiResponse<Profile>> {
    return this.http.post<ApiResponse<Profile>>(
      `${this.baseUrl}/client/auth/profile/update`,
      formData
    ).pipe(
      map((response) => {
        if (response.data) {
          this.updateCurrentUser({
            name: response.data.name,
            email: response.data.email,
            image: response.data.image
          });
        }
        return response;
      })
    );
  }
  


  resendCode(): Observable<ApiResponse<OtpResponse>> {
    const phone = localStorage.getItem('phoneNumber');
    if (!phone) {
      throw new Error('Phone number is missing! Make sure you set it during sign-up.');
    }

    const formData = new FormData();
    formData.append('phone', phone);
    formData.append('fcm_token', environment.fcm_token);
    formData.append('platform', environment.platform);

    return this.http.post<ApiResponse<OtpResponse>>(`${this.baseUrl}/client/auth/login`, formData).pipe(
      map((response) => {
        return response; // This ensures we return a properly typed response
      })
    );
  }



   setCurrentUser(loginVerifyResponse:LoginVerifyResponse){
    localStorage.setItem("client",JSON.stringify(loginVerifyResponse));
    this.currentUserSource.next(loginVerifyResponse);
  }

  updateCurrentUser(data: { name: string; image: string; email: string }) {
    const currentUser = this.getCurrentUser();
    if (currentUser) {
      const updatedUser: LoginVerifyResponse = {
        ...currentUser,
        user_data: {
          ...currentUser.user_data,
          name: data.name,
          image: data.image,
          email: data.email
        }
      };
  
      this.setCurrentUser(updatedUser);
    }
  }
  
  
  getCurrentUser(): LoginVerifyResponse | null {
    const user = localStorage.getItem("client");
    return user ? JSON.parse(user) : null;
  }
  
  getDecodeToken(token:string){
    return JSON.parse(atob(token.split('.')[1]));
  }

  logout(): Observable<ApiResponse<null>> {
  return this.http.get<ApiResponse<null>>(`${this.baseUrl}/client/auth/logout`, {}).pipe(
    map(response => {
      // Clear user data and token from storage after successful logout
      this.clearUserData();
      return response;
    })
  );
}

// Method to clear user session
clearUserData() {
  localStorage.removeItem("client");
  this.currentUserSource.next(null);
}

  isAuthenticated(): boolean {
    if (isPlatformBrowser(this.platformId)) {
      // Check if localStorage is available
      return !!localStorage.getItem('client');
    }
    return false; // Default to false for SSR or non-browser environments

  }
}
